<template lang="pug">
v-card(class="sdo-card")
  v-img(
    class="sdo-card__image text-right"
    :src="require('@/assets/group-sample.jpg')"
    alt="Изображение группы"
    @click=""
  )
    v-card-title {{ group.full_name }}
    v-card-text(v-if="group.teachers && group.teachers.length") Преподаватели:
      p.my-0.white--text(v-for="t in group.teachers"
        :key="t.id"
      ) {{ t.full_name }}
  v-card-actions.pt-0
    v-row.pa-4
      v-col.button-wrapper(v-if="isOrganization || isAdmin" cols="6")
        v-btn(:to="{ name: 'GroupView', params: { groupId: group.id }}" color="primary" text tile)
          v-icon(left small) mdi-eye
          | Просмотр
      v-col.button-wrapper(v-if="isOrganization || isAdmin" cols="6")
        v-btn(
          :to="{ name: 'GroupView', query: { tab: 2 }, params: { groupId: group.id }}"
          color="primary"
          text tile
        )
          v-icon(left) mdi-account-multiple
          | Наборы
      v-col.button-wrapper(v-if="isOrganization || isAdmin" cols="6")
        v-btn(
          :to="{ name: 'GroupView', params: { groupId: group.id }}"
          color="primary"
          text tile
        )
          v-icon(left) mdi-calendar-multiselect
          | Расписание группы
      v-col.button-wrapper(v-if="isOrganization || isAdmin" cols="6")
        v-btn(
          :to="{ name: 'GroupView', query: { tab: 1 }, params: { groupId: group.id }}"
          color="primary"
          text tile
        )
          v-icon(left) mdi-account
          | Список учеников
      v-col.button-wrapper(v-if="isAdmin" cols="6")
        v-btn(
          :to="{ name: 'TaskListForCheck', query: { group: group.id }}"
          color="primary"
          text tile
        )
          v-icon(left) mdi-text-box-outline
          | Проверка заданий
      v-col.button-wrapper(v-if="isOrganization || isAdmin" cols="6")
        v-btn(color="primary" :disabled="true" text tile)
          v-icon(left) mdi-pencil
          | Редактировать состав
      v-col.button-wrapper(cols="6")
        permissions-wrapper(
          :roles="[$conf.ROLES.organization]"
          exclude
          v-slot:default
        )
          v-btn(color="primary" :to="{ name: 'GroupChat', params: { id: group.id }}" text tile)
            v-icon(left small) mdi-chat
            | Написать в чат
      v-col.button-wrapper(v-if="isOrganization || isAdmin" cols="6")
        v-btn(
          color="error" text tile
          @click="$emit('delete')"
        )
          v-icon(left) mdi-delete
          | Удалить группу
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GroupCard',
  props: {
    group: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({ isAdmin: 'auth/isAdmin', isTeacher: 'auth/isTeacher', isOrganization: 'auth/isOrganization' }),
  },
};
</script>

<style lang="scss" scoped>

.button-wrapper {
  padding: 0.3rem 0.5rem;
}
::v-deep .v-btn__content {
  font-weight: 600;
}

::v-deep .v-responsive__content {
  display: flex;
  //align-items: flex-end;
  flex-direction: column;
  justify-content: flex-end;

  .v-card__title, .v-card__text {
    flex: 0;
    background: rgba(0,0,0,.5);
    backdrop-filter: blur(3px);
    color: #fff;
    //justify-content: center;
    text-align: left;
  }
}

</style>
